<div class="flex justify-between items-center mb-4">
  <h2 class="text-lg font-semibold">{{ 'SETUP.CITY.TITLE' | translate }}</h2>

  <button
    class="px-5 py-2 rounded-xl border border-indigo-600 text-indigo-600 hover:bg-indigo-50"
    (click)="openPopup()"
  >
    {{ 'SETUP.CITY.ADD_BUTTON' | translate }}
  </button>
</div>

<section class="p-4">
  <app-table
    [columns]="columns"
    [data]="cities"
    [actions]="actions"
    [enablePagination]="true"
    [pageSize]="10"
  >
  </app-table>

  <div *ngIf="cities.length === 0" class="text-center py-10 text-gray-400 bg-white border border-gray-200 ">
    {{ 'SETUP.CITY.NO_CITIES_FOUND' | translate }}
  </div>
</section>

<!-- ✅ SAME POPUP PATTERN -->
<app-popup
  [(show)]="showPopup"
  [title]="isEditMode ? 'SETUP.CITY.EDIT_CITY' : 'SETUP.CITY.ADD_CITY'"
  [fields]="clientFormFields"
  [data]="formData"
  [onSave]="handleSave"
  type="form">
</app-popup>

<!-- ✅ DELETE CONFIRMATION POPUP -->
<app-popup
  [(show)]="showDeletePopup"
  title="SETUP.CITY.DELETE_CITY"
  type="confirm"
  [message]="deleteMessage"
  confirmText="COMMON.DELETE"
  cancelText="COMMON.CANCEL"
  (confirmed)="confirmDelete()">
</app-popup>